/**
 * The TEMPLATE pill. Templates never sit in the folder tree, so in the
 * listings this only ever shows on trash rows (a deleted template waiting
 * to be restored); the template library itself shows it on every card.
 */

import { PenTool } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

export function TemplateBadge({ fileType, className }) {
  const { t } = useTranslation(['my-docs']);
  if (fileType !== 'template') return null;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-medium select-none',
        'bg-brand/10 text-brand border border-brand/20',
        className,
      )}
    >
      <PenTool className="w-3 h-3" />
      <span className="truncate">{t('my-docs:templates.badge')}</span>
    </span>
  );
}
